import { Button } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { fetchPaymentConfigRequest } from "../../../store/shopping/shopping.actions";
import { getPrivateLoungeUserSuccess } from "../../../store/user/privatelounge/privatelounge.actions";
import {
    fetchOtherUserProfileRequest,
    fetchOtherUserProfileSuccess,
    getMySubscriptionsRequest,
} from "../../../store/user/user.actions";
import UserAPI from "../../../store/user/user.api";
import {
    getImage,
    getMySubscriptions,
} from "../../../store/user/user.selector";

const SubsPrivateLounge = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const { mySubscriptions } = useSelector((state) => {
        return {
            mySubscriptions: getMySubscriptions(state),
        };
    });

    const cancelSubscription = (expiredDate, id) => {
        UserAPI.UnsubscribeUser({
            creator: id,
        })
            .then((X) => {
                Swal.fire({
                    title: "Cancel Subscription",
                    text: `Your subscription will be cancel at the end of your billing period on ${expiredDate}. 
				You can change your mind anytime before this date.`,
                    icon: "question",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonText: "Proceed",
                    showConfirmButton: true,
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                            title: "Cancel Subscription",
                            text: `Content will be available until ${expiredDate}.`,
                            icon: "success",
                            showCancelButton: true,
                            cancelButtonText: "Close",
                            showConfirmButton: false,
                            customClass: {
                                cancelButton: "order-1 right-gap",
                                confirmButton: "order-2",
                                denyButton: "order-3",
                            },
                        }).then((result) => {
                            if (result.isDismissed) {
                                dispatch(getMySubscriptionsRequest());
                            }
                        });
                    }
                });
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return (
        <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {mySubscriptions.map((xt) => {
                    let days = moment(xt.expiredTime).diff(moment(), "days");
                    return (
                        <div
                            key={xt.subscriber._id}
                            className="p-3 pb-4 rounded-lg border border-black-10"
                        >
                            <div className="flex flex-col items-center mb-5">
                                <img
                                    src={getImage(xt.subscriber.avatar)}
                                    className="w-14 h-14 rounded-full"
                                    alt=""
                                />
                                <div className="text-center">
                                    <h4 className="text-base text-[#2B1C50] font-extrabold">
                                        {xt.subscriber.fullName}
                                    </h4>
                                    <p className="text-sm text-[#707A89]">
                                        @{xt.subscriber.account.userName}
                                    </p>
                                </div>
                            </div>

                            <div className="text-sm font-medium text-black space-y-2.5">
                                <div className="flex items-center justify-between">
                                    <p className="capitalize">
                                        Subscribed since:
                                    </p>
                                    <p className="text-black-60">
                                        {moment(xt.dateCreated).fromNow()}
                                    </p>
                                </div>
                                <div className="flex items-center justify-between">
                                    <p className="capitalize">Renew on:</p>
                                    <p className="text-black-60">
                                        {days > 0 ? (
                                            <span className="text-bold">
                                                {" "}
                                                {moment(xt.expiredTime).format(
                                                    "DD/MM/YYYY"
                                                )}
                                            </span>
                                        ) : (
                                            <span className="text-bold text-danger">
                                                {moment(xt.expiredTime).format(
                                                    "DD/MM/YYYY"
                                                )}{" "}
                                                ({days} days)
                                            </span>
                                        )}
                                    </p>
                                </div>
                                <div className="flex items-center justify-between">
                                    <p className="capitalize">price:</p>
                                    <p className="text-black-60">
                                        {
                                            xt.subscriber.lounge
                                                .currencySubscription
                                        }{" "}
                                        {xt.billingPeriod === "monthly"
                                            ? xt.subscriber.lounge
                                                  .monthlySubscription
                                            : xt.subscriber.lounge
                                                  .annuallySubscription}{" "}
                                        /{" "}
                                        {xt.billingPeriod === "monthly"
                                            ? "month"
                                            : "year"}
                                    </p>
                                </div>
                                <div className="mt-2">
                                    {days > 0 ? (
                                        <button
                                            className="py-[7px] w-full rounded-lg text-sm font-bold text-white flex items-center justify-center border border-orange-color bg-orange-color capitalize"
                                            onClick={() => {
                                                dispatch(
                                                    fetchOtherUserProfileRequest(
                                                        xt.subscriber._id,
                                                        null
                                                    )
                                                );

                                                setTimeout(() => {
                                                    history(
                                                        `/${xt.subscriber.account.userName}/profile/private-lounge`
                                                    );
                                                }, 1000);
                                            }}
                                        >
                                            View Live
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                dispatch(
                                                    fetchPaymentConfigRequest()
                                                );
                                                dispatch(
                                                    fetchOtherUserProfileSuccess(
                                                        {
                                                            data: xt.subscriber,
                                                        }
                                                    )
                                                );
                                                dispatch(
                                                    getPrivateLoungeUserSuccess(
                                                        {
                                                            data: xt.subscriber
                                                                .lounge,
                                                        }
                                                    )
                                                );
                                                history(
                                                    "/page/subscription_payment"
                                                );
                                            }}
                                            fullWidth
                                            variant="contained"
                                            className="m-0 bg-danger text-white"
                                        >
                                            Renew Subscription
                                        </button>
                                    )}
                                    {days > 0 ? (
                                        xt.subscriptionStatus === "Inactive" ? (
                                            <button className="py-[7px] mt-2 w-full rounded-lg text-sm font-bold text-black-50 flex items-center justify-center border border-gray-200 bg-white capitalize">
                                                Content available to view until{" "}
                                                {moment(xt.expiredTime).format(
                                                    "DD/MM/YYYY"
                                                )}
                                            </button>
                                        ) : (
                                            <button
                                                className="py-[7px] mt-2 w-full rounded-lg text-sm font-bold text-black-50 flex items-center justify-center border border-gray-200 bg-white capitalize"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Cancel Subscription",
                                                        text: `Your subscription will be cancel at the end of your billing period on ${moment(
                                                            xt.expiredTime
                                                        ).format(
                                                            "DD/MM/YYYY"
                                                        )}. 
                                                        You can change your mind anytime before this date.`,
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        cancelButtonText:
                                                            "Cancel",
                                                        confirmButtonText:
                                                            "Proceed",
                                                        showConfirmButton: true,
                                                        customClass: {
                                                            cancelButton:
                                                                "order-1 right-gap",
                                                            confirmButton:
                                                                "order-2",
                                                            denyButton:
                                                                "order-3",
                                                        },
                                                    }).then((result) => {
                                                        if (
                                                            result.isConfirmed
                                                        ) {
                                                            cancelSubscription(
                                                                moment(
                                                                    xt.expiredTime
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                ),
                                                                xt.subscriber
                                                                    ._id
                                                            );
                                                        }
                                                    });
                                                }}
                                            >
                                                Cancel Subscription
                                            </button>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {mySubscriptions.length === 0 && (
                <div className="flex flex-col items-center justify-start pt-9 width-100-per">
                    <p className="text-sm text-black-50 mb-5">
                        You do not have any active subscriptions
                    </p>
                    <button className="py-2.5 px-[18px] bg-orange-color text-white text-sm font-bold rounded-lg">
                        Start your subscription
                    </button>
                </div>
            )}
        </div>
    );
};

export default SubsPrivateLounge;
